import {
  Button, Columns, LoadingModule, SaveFormModule,
} from '@domain-group/suit-theme'

import useBrand, { useBrandForm } from '@hooks/useBrand'
import useCurrentUser from '@hooks/useCurrentUser'

import handleCallbackAction from '@functions/handleCallbackAction'

import BrandTools from '../../../../components/BrandTools'
import PageLayout from '../../../../components/PageLayout'

import AdditionalSettings from '../AdditionalSettings'
import ArtworkSettings from '../ArtworkSettings'
import BrandCustomProfiles from '../BrandCustomProfiles'
import Features from '../Features'
import TemplateSettings from '../TemplateSettings'

const PageContent = (props: {brandId: number}) => {
  const { brandId } = props

  const brandPayload = useBrand({ id: brandId })

  const {
    callbacks: { updateBrand: updateFn },
    brand,
    loading,
    updating,
  } = brandPayload

  const brandFormPayload = useBrandForm(brand)

  const { entityState, saveEnabled } = brandFormPayload

  const updateBrandSettingsPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Brand Updated',
  }

  const { isAdmin, isBrandUser } = useCurrentUser()

  return (
    <PageLayout activeTabBarItemKey="settings" entityPayload={brandPayload}>
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        <TemplateSettings brandFormPayload={brandFormPayload} />

        <ArtworkSettings brandFormPayload={brandFormPayload} />

        <BrandCustomProfiles brandId={brandId} />

        <Features brandFormPayload={brandFormPayload} />

        {!isBrandUser && (
          <AdditionalSettings brandFormPayload={brandFormPayload} />
        )}
        <SaveFormModule>
          <Button
            buttonStyle="primaryCreate"
            disabled={!saveEnabled}
            loading={updating}
            onClick={() => handleCallbackAction(updateBrandSettingsPayload)}
            size="medium"
            style={{ width: '100%' }}
          >
            Save Details
          </Button>
        </SaveFormModule>
      </Columns.Main>

      <Columns.Sidebar>
        {isAdmin && (<BrandTools brandPayload={brandPayload} brandSettingsTab />)}
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
